import { render, staticRenderFns } from "./LaboratoryDevicesModalForm.vue?vue&type=template&id=b5d8ecfe&"
import script from "./LaboratoryDevicesModalForm.vue?vue&type=script&lang=js&"
export * from "./LaboratoryDevicesModalForm.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryDevicesModalForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports